import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dateSet" }
const _hoisted_2 = { class: "year" }
const _hoisted_3 = { class: "month" }
const _hoisted_4 = ["onClick"]

import { useCalculatorStore } from "@/store/calculator";
import { useCalendarStore } from "@/store/calendar";
import { reactive, toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MonthDialog',
  props: {
  calculator: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props;

const calendarStore = useCalendarStore();
const calculatorStore = useCalculatorStore();





const year = props.calculator
  ? toRefs(calculatorStore).year
  : toRefs(calendarStore).year;

const confirm = (value: number) => {
  if (props.calculator) calculatorStore.month = value;
  else calendarStore.month = value;
  closeDialog();
};

const closeDialog = () => {
  emit("close");
};

const yearDecrease = () => {
  if (props.calculator) calculatorStore.year = calculatorStore.year - 1;
  else calendarStore.year = calendarStore.year - 1;
};

const yearIncrease = () => {
  if (props.calculator) calculatorStore.year = calculatorStore.year + 1;
  else calendarStore.year = calendarStore.year + 1;
};

const months = reactive({
  januar: { name: "Sty", value: 1 },
  februar: { name: "Lut", value: 2 },
  march: { name: "Mar", value: 3 },
  april: { name: "Kwi", value: 4 },
  may: { name: "Maj", value: 5 },
  june: { name: "Cze", value: 6 },
  july: { name: "Lip", value: 7 },
  august: { name: "Sie", value: 8 },
  september: { name: "Wrz", value: 9 },
  october: { name: "Paź", value: 10 },
  november: { name: "Lis", value: 11 },
  december: { name: "Gru", value: 12 },
});

return (_ctx: any,_cache: any) => {
  const _component_base_dialog = _resolveComponent("base-dialog")!

  return (_openBlock(), _createBlock(_component_base_dialog, { onClose: closeDialog }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("i", {
            onClick: yearDecrease,
            class: "fa-solid fa-arrow-left"
          }),
          _createElementVNode("span", null, _toDisplayString(_unref(year)), 1),
          _createElementVNode("i", {
            onClick: yearIncrease,
            class: "fa-solid fa-arrow-right"
          })
        ]),
        _createElementVNode("section", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(months, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "month__item",
              key: item.value,
              onClick: ($event: any) => (confirm(item.value))
            }, _toDisplayString(item.name), 9, _hoisted_4))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }))
}
}

})